function DB(){
    const products = [
        {
            id: 0,
            name: "Ovo ao leite",
            quantity: 1,
            options: {
                weights: [0, 1],
                packings: [0, 1, 2,3]
            }
        },

        {
            id: 1,
            name: "Ovo ao leite crocante",
            quantity: 1,
            options: {
                weights: [20, 21],
                packings: [0, 1, 2,3],
            }
        },

        {
            id: 2,
            name: "Ovo ao leite trufado",
            quantity: 1,
            options: {
                weights: [3, 4],
                fillings: [0, 1, 2, 3, 4, 5],
                packings: [0, 1, 2,3],
            }
        },

        {
            id: 4,
            name: "Ovo branco",
            quantity: 1,
            options: {
                weights: [9, 10],
                packings: [0, 1, 2,3],
            }
        },

        {
            id: 5,
            name: "Ovo branco crocante",
            quantity: 1,
            options: {
                weights: [22, 23],
                packings: [0, 1, 2,3],
            }
        },

        {
            id: 6,
            name: "Ovo branco trufado",
            quantity: 1,
            options: {
                weights: [12, 13],
                fillings: [0, 1, 2, 3, 4, 5],
                packings: [0, 1, 2,3],
            }
        },

        {
            id: 7,
            name: "Ovo de colher ao leite",
            quantity: 1,
            options: {
                weights: [15, 16],
                fillings: [0, 1, 2, 4, 5, 6],
                packings: [0, 1, 2,3],
            }
        }
    ];

    const defaultOptions = {
        weights: {
            name: 'Peso',
            description: null,
            values: [
                {id: 0, value: "250g", price: 40, mark: false},
                {id: 1, value: "500g", price: 65, mark: false},
                {id: 2, value: "1kg", price: 79, mark: false},
                {id: 3, value: "250g", price: 60, mark: false},
                {id: 4, value: "500g", price: 80, mark: false},
                {id: 5, value: "1kg", price: 95, mark: false},
                {id: 6, value: "250g", price: 38, mark: false},
                {id: 7, value: "500g", price: 64, mark: false},
                {id: 8, value: "1kg", price: 85, mark: false},
                {id: 9, value: "250g", price: 55, mark: false},
                {id: 10, value: "500g", price: 75, mark: false},
                {id: 11, value: "1kg", price: 94, mark: false},
                {id: 12, value: "250g", price: 75, mark: false},
                {id: 13, value: "500g", price: 95, mark: false},
                {id: 14, value: "1kg", price: 109, mark: false},
                {id: 15, value: "250g", price: 70, mark: false},
                {id: 16, value: "500g", price: 85, mark: false},
                {id: 17, value: "250g", price: 75, mark: false},
                {id: 18, value: "350g", price: 85, mark: false},
                {id: 19, value: "20un", price: 17, mark: true},
                {id: 20, value: "250g", price: 42, mark: false},
                {id: 21, value: "500g", price: 67, mark: false},
                {id: 22, value: "250g", price: 57, mark: false},
                {id: 23, value: "500g", price: 77, mark: false},
                {id: 24, value: "250g", price: 30, mark: false},
                {id: 25, value: "350g", price: 35, mark: false},
            ]
        },

        fillings: {
            name: 'Recheio',
            description: null,
            values: [
                {id: 0, value: "Brigadeiro", mark: false},
                {id: 1, value: "Prestigio", mark: false},
                {id: 2, value: "Maracuja", mark: false},
                {id: 3, value: "Morango", mark: false},
                {id: 4, value: "Ninho", mark: false},
                {id: 5, value: "Oreo", mark: false},
                {id: 6, value: "Ninho com Nutella (+ R$ 5,00)", price: 5, mark: false}
            ]
        },

        packings: {
            name: 'Embrulho',
            description: 'Escolha o tema da embalagem no WhatsApp',
            values: [
                {id: 0, value: "Para homem", mark: false},
                {id: 1, value: "Para mulher", mark: false},
                {id: 2, value: "Infantil (menino)", mark: false},
                {id: 3, value: "Infantil (menina)", mark: false},
                {id: 4, value: "Caixa com copo (+ R$ 10)", price: 10, mark: false},
                {id: 5, value: "Caixa sem copo (+ R$ 5)", price: 5, mark: false}
            ]
        },

        surprises: {
            name: 'Surpresa',
            description: null,
            values: [
                {id: 0, value: "Com brinquedo (+ R$ 2,00)", price: 2, mark: false},
                {id: 1, value: "Sem brinquedo", price: 0, mark: false}
            ]
        },

        egg: {
            name: 'Ovo',
            description: null,
            values: [
                {id: 0, value: "Ao leite", mark: false},
                {id: 1, value: "Ao leite crocante", mark: false},
                {id: 2, value: "Branco", mark: false},
                {id: 3, value: "Branco crocante", mark: false},
                {id: 4, value: "Meio a meio", mark: false},
            ]
        }
    };

    function getProducts(){
        let newProducts = [...products];
        
        newProducts = newProducts.map(product => {
            const productOptions = product.options;

            for(let productOptionName in productOptions){
                const productOptionsIDs = productOptions[productOptionName];

                productOptions[productOptionName] = {...defaultOptions[productOptionName]};

                if (productOptionsIDs.length) {
                    productOptions[productOptionName].values = productOptions[productOptionName].values.filter(value => (
                        productOptionsIDs.find(ID => ID === value.id) !== undefined
                    ));
                }
            }

            return product;
        });

        return newProducts;
    }

    function getProductMarkedOptions(options) {
        const markedOptions = [];

        for(let optionName in options){
            const option = options[optionName];
            const markedOption = option.values.find(value => value.mark === true);
            const optionText = option.name;

            if(!markedOption) continue;
            
            markedOptions.push({markedOption, optionText});
        }
        
        return markedOptions;
    }

    return {
        getProducts,
        getProductMarkedOptions
    };
}

export default DB;